(() => {
  const parseNumber = (value) => {
    if (typeof value !== 'string') value = String(value ?? '');
    const normalized = value.replace(/\s/g, '').replace(',', '.').replace(/[^0-9.\-]/g, '');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const setSliderFromFields = (priceRange) => {
    const slider = priceRange?.querySelector('[data-cr-price-slider]');
    if (!slider) return;

    const fields = priceRange.querySelectorAll('input.field__input');
    const minRange = slider.querySelector('.cr-price-slider__range--min');
    const maxRange = slider.querySelector('.cr-price-slider__range--max');
    if (fields.length < 2 || !minRange || !maxRange) return;

    const absoluteMax = Number(slider.dataset.max || maxRange.max || 0);
    let min = parseNumber(fields[0].value);
    let max = parseNumber(fields[1].value);

    if (min === null) min = 0;
    if (max === null) max = absoluteMax;

    min = Math.max(0, Math.min(min, absoluteMax));
    max = Math.max(min, Math.min(max, absoluteMax));

    minRange.value = min;
    maxRange.value = max;
  };

  const setFieldsFromSlider = (range) => {
    const priceRange = range.closest('price-range');
    const slider = range.closest('[data-cr-price-slider]');
    if (!priceRange || !slider) return;

    const fields = priceRange.querySelectorAll('input.field__input');
    const minRange = slider.querySelector('.cr-price-slider__range--min');
    const maxRange = slider.querySelector('.cr-price-slider__range--max');
    if (fields.length < 2 || !minRange || !maxRange) return;

    let min = Number(minRange.value);
    let max = Number(maxRange.value);

    if (range === minRange && min > max) {
      min = max;
      minRange.value = min;
    }
    if (range === maxRange && max < min) {
      max = min;
      maxRange.value = max;
    }

    fields[0].value = min <= 0 ? '' : min.toFixed(2);
    const absoluteMax = Number(slider.dataset.max || maxRange.max || 0);
    fields[1].value = max >= absoluteMax ? '' : max.toFixed(2);
  };

  document.addEventListener('input', (event) => {
    const target = event.target;

    if (target.matches('.cr-price-slider__range')) {
      setFieldsFromSlider(target);
      return;
    }

    if (target.matches('price-range input.field__input')) {
      setSliderFromFields(target.closest('price-range'));
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches('price-range input.field__input')) {
      setSliderFromFields(event.target.closest('price-range'));
    }
  }, true);

  document.querySelectorAll('price-range').forEach(setSliderFromFields);
})();

(() => {
  const syncFilterReset = () => {
    const active = [...new URLSearchParams(window.location.search)].some(([key,value]) => key.startsWith('filter.') && value !== '');
    document.querySelectorAll('[data-cr-filter-reset]').forEach(element => { element.hidden = !active; });
  };
  syncFilterReset();
  window.addEventListener('popstate', syncFilterReset);
  const grid = document.querySelector('#ProductGridContainer');
  if (grid) new MutationObserver(syncFilterReset).observe(grid, { childList:true, subtree:true });
  document.addEventListener('change', event => {
    if (event.target.closest('facet-filters-form')) requestAnimationFrame(syncFilterReset);
  });
})();
